<template>
  <div class="formula" @mouseleave="closeDialog">
    <div class="gs" id="box_div_editor_client" v-show="visible">
      <i class="carts"/>
      <div class="gs_tit">
        <ul>
          <li id="twoo1" :class="{'hover':showStatus === 0}">
            <input
              type="button"
              value="常用公式"
              class="gs_an"
              style=" background:none; border:0px; cursor:pointer"
              @click="setTab(0)"
            >
          </li>
          <li id="twoo2" :class="{'hover':showStatus === 1}">
            <input
              type="button"
              value="数学符号"
              style=" background:none; border:0px; cursor:pointer"
              @click="setTab(1)"
            >
          </li>
          <li id="twoo3" :class="{'hover':showStatus === 2}">
            <input
              type="button"
              value="希腊字母"
              style=" background:none; border:0px; cursor:pointer"
              @click="setTab(2)"
            >
          </li>
        </ul>
      </div>
      <div id="div_FormulaBlock" class="menuDiv">
        <div id="con_twoo_1" v-if="showStatus === 0">
          <div class="gs_nr">
            <ul>
              <li class="fc1">
                <a
                  @click="insertWrite('\\frac', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc3">
                <a
                  @click="insertWrite('x^', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc4">
                <a
                  @click="insertWrite('x_', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc5">
                <a
                  @click="insertWrite('x_{}^{}', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc6">
                <a
                  @click="insertWrite('\\bar{x}', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc7">
                <a
                  @click="insertWrite('\\sqrt', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc8">
                <a
                  @click="insertWrite('\\nthroot3{}', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc9">
                <a
                  @click="insertWrite('\\nthroot', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc10">
                <a
                  @click="insertWrite('\\sum^{}_{n=}', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc11">
                <a
                  @click="insertWrite('\\sum', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc12">
                <a
                  @click="insertWrite('\\log_{}\\left(\\right)', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc13">
                <a
                  @click="insertWrite('\\ln', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
            </ul>
          </div>
        </div>
        <div id="con_twoo_2" v-else-if="showStatus === 1">
          <div class="gs_nr">
            <ul>
              <li class="fa1">
                <a
                  @click="insertWrite('+', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa2">
                <a
                  @click="insertWrite('-', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa3">
                <a
                  @click="insertWrite('\\pm', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa4">
                <a
                  @click="insertWrite('\\times', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa5">
                <a
                  @click="insertWrite('\\ast', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa6">
                <a
                  @click="insertWrite('\\div', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa7">
                <a
                  @click="insertWrite('/', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa8">
                <a
                  @click="insertWrite('\\infty', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa9">
                <a
                  @click="insertWrite('\\partial', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa10">
                <a
                  @click="insertWrite('\\bigtriangleup', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa11">
                <a
                  @click="insertWrite('=', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa12">
                <a
                  @click="insertWrite('\\ne', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa13">
                <a
                  @click="insertWrite('\\approx', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa14">
                <a
                  @click="insertWrite('>', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa15">
                <a
                  @click="insertWrite('<', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa16">
                <a
                  @click="insertWrite('\\ge', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa17">
                <a
                  @click="insertWrite('\\le', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
            </ul>
          </div>
        </div>
        <div id="con_twoo_3" v-else-if="showStatus === 2">
          <div class="gs_nr">
            <ul>
              <li class="fb1">
                <a
                  @click="insertWrite('\\alpha', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb2">
                <a
                  @click="insertWrite('\\beta', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb3">
                <a
                  @click="insertWrite('\\gamma', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb4">
                <a
                  @click="insertWrite('\\delta', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb5">
                <a
                  @click="insertWrite('\\varepsilon', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb6">
                <a
                  @click="insertWrite('\\varphi', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb7">
                <a
                  @click="insertWrite('\\lambda', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb8">
                <a
                  @click="insertWrite('\\mu', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb9">
                <a
                  @click="insertWrite('\\rho', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb10">
                <a
                  @click="insertWrite('\\sigma', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb11">
                <a @click="insertWrite('\\omega', false)" href="javascript:void(0);">&nbsp;</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "formula",
    props: {
      visible: { type: Boolean, default: false },
      toggleFn: { type: Function, default: () => null }
    },
    data() {
      return {
        showStatus: 0
      }
    },
    methods: {
      insertWrite(type, bool) {
        this.$emit('toggleFn', type, bool)
      },
      setTab(type) {
        this.showStatus = type
      },
      closeDialog() {
        this.$emit('update:visible', false)
      }
    }
  }
</script>
<style lang="scss" scoped>
  $bgUrl: '~@/assets/images/formula/';
  .formula {

    .gs {
      width: 328px;
      position: absolute;
      top: 25px;
      left: -45px;

      .carts {
        width: 328px;
        height: 8px;
        background: url($bgUrl + 'jt.png') no-repeat center top;
        display: block
      }
    }

    .gs_tit {
      width: 328px;
      background: url($bgUrl + 'gs_tit.gif') repeat-x;
      height: 29px;
      border-left: 1px solid #c1cee3;
      border-right: 1px solid #c1cee3;

      ul {
        padding-top: 7px;
        overflow: hidden;

        li {
          float: left;
          margin-left: 12px;
          display: inline-block;
          font-size: 14px !important;
          font-weight: bold;
          cursor: pointer;
          line-height: 24px;
          height: 24px;
          width: 93px;
          background: url($bgUrl + 'bg-menu-tab.gif') no-repeat 0 0;
          text-align: center;

          input {
            height: 24px;
            width: 93px;
            display: block;
            outline: none;
          }

          &.hover {
            background: url($bgUrl + 'bg-menu-tab.gif') no-repeat 0 -24px;
          }
        }
      }
    }

    .gs_nr {
      border: 1px solid #c1cee3;
      border-top: none;
      background: #fff;
      overflow: hidden;
      width: 328px;
      padding: 10px 0 10px 10px;
    }

    .gs_nr li {
      margin: 0 6px 6px 0;
      float: left;
      width: 30px;
      height: 30px;
      background: url($bgUrl + 'function.gif') no-repeat;
      cursor: pointer;
      text-indent: -9999px;
    }

    .gs_nr li a {
      display: block;
      height: 30px;
      text-decoration: none;
      width: 30px;
      outline: medium none;
    }

    .gs_nr li.fa1 {
      background-position: 0px 0px;
    }

    .gs_nr li.fa2 {
      background-position: -34px 0px;
    }

    .gs_nr li.fa3 {
      background-position: -68px 0px;
    }

    .gs_nr li.fa4 {
      background-position: -102px 0px;
    }

    .gs_nr li.fa5 {
      background-position: -136px 0px;
    }

    .gs_nr li.fa6 {
      background-position: -170px 0px;
    }

    .gs_nr li.fa7 {
      background-position: -204px 0px;
    }

    .gs_nr li.fa8 {
      background-position: -238px 0px;
    }

    .gs_nr li.fa9 {
      background-position: -272px 0px;
    }

    .gs_nr li.fa10 {
      background-position: 0px -34px;
    }

    .gs_nr li.fa11 {
      background-position: -34px -34px;
    }

    .gs_nr li.fa12 {
      background-position: -68px -34px;
    }

    .gs_nr li.fa13 {
      background-position: -102px -34px;
    }

    .gs_nr li.fa14 {
      background-position: -136px -34px;
    }

    .gs_nr li.fa15 {
      background-position: -170px -34px;
    }

    .gs_nr li.fa16 {
      background-position: -204px -34px;
    }

    .gs_nr li.fa17 {
      background-position: -238px -34px;
    }

    .gs_nr li.fb1 {
      background-position: 0px -68px;
    }

    .gs_nr li.fb2 {
      background-position: -34px -68px;
    }

    .gs_nr li.fb3 {
      background-position: -68px -68px;
    }

    .gs_nr li.fb4 {
      background-position: -102px -68px;
    }

    .gs_nr li.fb5 {
      background-position: -136px -68px;
    }

    .gs_nr li.fb6 {
      background-position: -170px -68px;
    }

    .gs_nr li.fb7 {
      background-position: -204px -68px;
    }

    .gs_nr li.fb8 {
      background-position: -238px -68px;
    }

    .gs_nr li.fb9 {
      background-position: -272px -68px;
    }

    .gs_nr li.fb10 {
      background-position: 0px -102px;
    }

    .gs_nr li.fb11 {
      background-position: -34px -102px;
    }

    .gs_nr li.fc1 {
      background-position: 0px -136px;
    }

    .gs_nr li.fc2 {
      background-position: -34px -136px;
    }

    .gs_nr li.fc3 {
      background-position: -68px -136px;
    }

    .gs_nr li.fc4 {
      background-position: -102px -136px;
    }

    .gs_nr li.fc5 {
      background-position: -136px -136px;
    }

    .gs_nr li.fc6 {
      background-position: -170px -136px;
    }

    .gs_nr li.fc7 {
      background-position: -204px -136px;
    }

    .gs_nr li.fc8 {
      background-position: -238px -136px;
    }

    .gs_nr li.fc9 {
      background-position: -272px -136px;
    }

    .gs_nr li.fc10 {
      background-position: 0px -170px;
    }

    .gs_nr li.fc11 {
      background-position: -34px -170px;
    }

    .gs_nr li.fc12 {
      background-position: -68px -170px;
    }

    .gs_nr li.fc13 {
      background-position: -102px -170px;
    }

    .gs_tit .gs_an {
      background: none;
    }
  }
</style>
